import React, { ReactNode } from 'react'
import { Button } from '@arco-design/web-react'

interface Props {
  icon?: ReactNode
  text: string
  onClick?: () => void
}

function LoginBtn({ icon, text, onClick }: Props) {
  return (
    <div>
      <Button
        onClick={onClick}
        style={{
          width: '100%',
          height: '48px',
          borderRadius: '8px',
          backgroundColor: '#fff',
          border: '1px solid #888BA6',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '16px'
        }}
      >
        {icon}
        {text}
      </Button>
    </div>
  )
}

export default LoginBtn
